// src/services/bi/PriorityFormationsSection.jsx
import React, { useState, useEffect, useRef } from 'react';
import { getPriorityFormations } from './dashboardAiService';
import FormationDetailModal from './FormationDetailModal';

const PriorityFormationsSection = () => {
  const [formations, setFormations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFormation, setSelectedFormation] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    fetchPriorityFormations();
  }, []);

  const fetchPriorityFormations = async () => {
    setLoading(true);
    try {
      const data = await getPriorityFormations(5);
      setFormations(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (formation) => {
    setSelectedFormation(formation);
    setModalOpen(true);
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <div className="priority-section">
        <div className="priority-loading">
          <div className="priority-loading__spinner"></div>
          <span>Chargement des formations prioritaires...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="priority-section">
        <div className="priority-error">
          ⚠️ Erreur : {error}
        </div>
      </div>
    );
  }

  if (formations.length === 0) {
    return (
      <div className="priority-section">
        <div className="priority-empty">
          🏆 Aucune formation avec au moins 5 prospects chauds pour le moment.
        </div>
      </div>
    );
  }

  return (
    <div className="priority-section">
      <div className="priority-header">
        <h2 className="priority-title">
          <span className="priority-icon">🏆</span>
          Formations prioritaires (≥ 5 prospects chauds)
        </h2>
        <p className="priority-subtitle">
          Formations recommandées pour l'ouverture de nouvelles sessions
        </p>
      </div>

      {/* Conteneur avec flèches */}
      <div className="priority-carousel-wrapper">
        <button className="carousel-arrow carousel-arrow--left" onClick={scrollLeft}>
          ‹
        </button>

        <div className="priority-scroll-container" ref={scrollContainerRef}>
          <div className="priority-grid-horizontal">
            {formations.map((formation, index) => (
              <div key={formation.id} className="priority-card">
                <div className="priority-card__rank">
                  <span className="priority-rank-number">{index + 1}</span>
                </div>
                <div className="priority-card__content">
                  <h3 className="priority-card__title">{formation.intitule}</h3>
                  <div className="priority-card__badge">
                    <span 
                      className="priority-badge"
                      style={{ backgroundColor: formation.priorite.color + '20', color: formation.priorite.color }}
                    >
                      {formation.priorite.label} priorité
                    </span>
                  </div>
                  <div className="priority-card__stats">
                    <div className="priority-stat">
                      <span className="priority-stat-label">🔥 Prospects chauds</span>
                      <span className="priority-stat-value">{formation.hot_prospects_count}</span>
                    </div>
                    <div className="priority-stat">
                      <span className="priority-stat-label">📊 Score moyen IA</span>
                      <span className="priority-stat-value">{formation.average_score}%</span>
                    </div>
                  </div>
                  <div className="priority-card__recommendation">
                    <span className="recommendation-icon"></span>
                    <p className="recommendation-text">{formation.recommandation_ia}</p>
                  </div>
                  <button 
                    className="priority-card__button"
                    onClick={() => handleViewDetails(formation)}
                  >
                    Voir détails →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button className="carousel-arrow carousel-arrow--right" onClick={scrollRight}>
          ›
        </button>
      </div>

      {selectedFormation && (
        <FormationDetailModal
          formation={selectedFormation}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default PriorityFormationsSection;